import React, { useEffect, useState } from 'react';
import axios from '../axios';

const PlaceDetail = ({ placeId, onBack, onReserve }) => {
  const [place, setPlace] = useState(null);
  const [contents, setContents] = useState([]);
  const googleMapsView = (place) => {
    if (place.address && place.address.trim() !== '') {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place.address)}`;
    }
    const url = place.google_map_url || '';
    return url.includes('/embed') ? url.replace('/maps/embed?', '/maps?') : url;
  };

  useEffect(() => {
    if (!placeId) return;
    axios
      .get(`/api/places/${placeId}`)
      .then((res) => {
        setPlace(res.data.place);
        setContents(res.data.contents || []);
      })
      .catch(() => {
        setPlace(null);
        setContents([]);
      });
  }, [placeId]);

  const renderContent = (content) => {
    switch (content.content_type) {
      // テキスト本文
      case 1:
        return (
          <p key={content.id} className="mb-4" style={{ whiteSpace: 'pre-line' }}>
            {content.body}
          </p>
        );
      // 見出し
      case 2:
        return (
          <h2 key={content.id} className="h5 font-weight-bold mt-4 mb-3">
            {content.body}
          </h2>
        );
      // 画像
      case 3:
        return (
          <figure key={content.id} className="mb-4">
            <img src={content.photo_url_medium} alt={content.body || ''} className="w-100"/>
            {content.body && (
              <figcaption className="mt-1 text-muted">
                {content.body}
              </figcaption>
            )}
          </figure>
        );
      // Youtubeコード
      case 4:
        return (
          <div key={content.id} className="mb-4 embed-responsive embed-responsive-16by9" dangerouslySetInnerHTML={{ __html: content.body }}
          />
        );
      // 引用
      case 5:
        return (
          <blockquote key={content.id} className="blockquote pl-3 border-left mb-4">
            <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
              {content.body}
            </p>
          </blockquote>
        );
      default:
        return null;
    }
  };

  if (!place) return null;

  return (
    <main className="bg-white min-vh-100">
      <div className="container col-md-8 col-lg-6 py-3">
        <button className="btn text-gray px-0 mb-2" onClick={onBack}>← 戻る</button>

        <img src={place.image_data_medium || place.image_data} alt={place.name} className="w-100 mb-3" />
        <h1 className="h4 font-weight-bold mb-3">{place.name}</h1>
        {contents.map(renderContent)}
        <h2 className="h5 font-weight-bold mb-2">詳細情報</h2>
        {place.address && <p><strong>住所：</strong>{place.address}</p>}
        {place.stations && <p><strong>交通：</strong>{place.stations}</p>}
        {place.opening_hours && <p className="mb-1"><strong>営業時間：</strong>{place.opening_hours}</p>}
        {place.description && <p className="mb-1"><strong>詳細：</strong>
        <a href={place.description} target="_blank" rel="noopener noreferrer" className="text-primary">{place.description}</a></p>}

        {place.google_map_url && (
          <>
            <div className="mb-3 mt-2">
              <iframe
                title="map"
                src={place.google_map_url}
                className="w-100"
                height="240"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-right small">
              <a href={googleMapsView(place)} target="_blank" rel="noopener noreferrer">
                大きい地図で見る
              </a>
            </p>
          </>
        )}

        <div className="d-flex mt-3">
          <button type="button" className="w-50 border-0 text-fz-13px py-3 text-dark mr-1" style={{ backgroundColor: '#E0E0E0' }} onClick={onBack}>
            戻る
          </button>
          <button type="button" className="w-50 border-0 py-3 text-fz-13px text-white ml-1" style={{ backgroundColor: '#FF4D5B' }} onClick={() => typeof onReserve === 'function' && onReserve(place)}>
            この店舗を選択
          </button>
        </div>
        <p className="text-center text-muted mt-2 mb-0" style={{ fontSize: '12px' }}>
          ※予約手数料はかかりません。予約画面に進みます。
        </p>
      </div>
    </main>
  );
};

export default PlaceDetail;
